<template>
    <section class="faq-section" id="faq">
        <div class="question-shevrone">
            <img src="../assets/icons/question-shevrone.svg" alt="">
        </div>
        <div class="container">
            <div class="row center-lg align-left">
                <div class="col-xs-12 col-gi-10">
                    <h3 class="section-title faq-title margin-bottom bordered-heading headline_h2">FAQ – <br>Häufig gestellte Fragen</h3>
                    <div class="faq-container">
                        <div class="faq-card" v-for="(faq, index) in faqList" :key="index">
                            <div class="faq-title text" :class="{active: selectedIndex === index}" @click="toggle(index)">{{ faq.title }}</div>
                            <CollapseTransition dimension="height">
                                <div class="faq-content text" v-show="selectedIndex === index" v-html="faq.description"></div>
                            </CollapseTransition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { CollapseTransition } from "@ivanv/vue-collapse-transition"
export default {
    name: "FAQ",
    components: {
        CollapseTransition
    },
    data: () => ({
        selectedIndex: null,
        faqList: [
            {
                title: 'Ich verkaufe mein Auto – welche Möglichkeiten habe ich?',
                description: 'Wenn du dein Auto bequem, schnell und sicher über PKW.de verkaufen möchtest, hast du zwei Möglichkeiten: Entweder du fährst zu einer unserer PKW.de-Ankaufstationen in deiner Nähe oder du entscheidest dich für den bequemen Onlineverkauf. Dort erstellst du ein Verkaufsexposé, legst mit unseren PKW,de-Experten einen Mindestpreis und Auktionsdauer fest – und schon kann es losgehen.'
            },
            {
                title: 'Auto verkaufen – was muss ich beachten?',
                description: 'Wenn du dein Auto bei PKW.de verkaufst – wenig. Du entscheidest dich, ob du lokal an eine PKW.de-Ankaufstation in deiner Nähe verkaufen möchtest oder dein Auto online Händlern in ganz Deutschland anbieten möchtest. Beides ist kostenlos, sicher und ohne lästige Telefonate. Du machst entweder einen Termin bei einer Ankaufstation oder erstellst mit wenigen Klicks ein Exposé und lässt das Auto vor deiner eigenen Haustür begutachten. Unsere PKW.de-Experten begleiten dich auf jedem Schritt. Und wenn du dein Auto verkauft hast, übernimmt der Händler alles weitere.'
            },
            {
                title: 'Auto verkaufen: lokal oder online – was sind die Unterschiede?',
                description: 'Wenn du deinen Gebrauchtwagen lokal an eine PKW.de-Ankaufstation verkaufen möchtest, bekommst du nach ein paar Klicks eine erste Preisbewertung in unter 1 Minute. Danach vereinbarst du einen Termin bei einer Ankaufstation in deiner Nähe. Der Händler schaut sich dort dein Auto an und macht dir ein Angebot. Wenn du zustimmst, bekommst du den Verkaufspreis und lässt dein Auto, Schlüssel und Fahrzeugbrief dort. <br/>Möchtest du lieber bundesweit online verkaufen, erstellst du nach der Preisbewertung ein Exposé. Bei Bedarf schaut sich ein Gutachter das Fahrzeug bei dir zuhause an. Mit unseren PKW.de-Experten legst du Mindestpreis, Auktionsdauer und – falls du möchtest – einen Sofortkauf-Preis fest. Schon können geprüfte Händler aus ganz Deutschland auf dein Auto bieten. Du erhältst das Höchstgebot und entscheidest, ob du zu diesem Preis verkaufen möchtest. Entscheidest du dich zum Verkauf, übernimmt der Händler Abholung, Abmeldung und alles weitere.'
            },
            {
                title: 'Wann das eigene Auto verkaufen – was ist das beste Alter des Gebrauchtwagens?',
                description: 'Ein Neuwagen verliert in den ersten drei Jahren am meisten an Wert. Danach flacht die Kurve des Wertverlustes deutlich ab. Ansonsten kommt es jedoch auf individuelle Faktoren an, Zustand, Laufleistung, Ausstattung. Auch wichtig: eher psychologische Kriterien – so bringt ein Gebrauchtwagen mit 96.000 km Laufleistung noch mehr als ein Auto mit 103.000 km auf dem Tacho. Nach fünf bis neun Jahren verkaufen die meisten Autobesitzer ihr Auto und legen sich ein neues Auto zu.'
            },
            {
                title: 'Wann ist die beste Zeit für einen Autoverkauf?',
                description: 'Die beste Jahreszeit zum Gebrauchtwagenverkauf hängt von vielen Faktoren ab. Denn im Frühjahr und Sommer sind die Preise für Neuwagen erwartungsgemäß durch Rabatte und Nachlässe am günstigsten. Tendenziell steigen die Preise am Gebrauchtwagenmarkt im Herbst an, so dass ein privater Autoverkäufer hier den höchsten Preis für sein Auto erzielt. Dafür ist der Preis für das nächste Fahrzeug auch höher. Tipp: Regelmäßig den Markt im Blick behalten und <a href="/auto-verkaufen/auto-bewerten/" title="Preisbewertung">Preisbewertung</a>.'
            },
            {
                title: 'Wer kauft mein Auto?',
                description: 'Bei PKW.de verkaufst du dein Auto – egal ob lokal oder online ausschließlich an geprüfte und zertifizierte Händler. Durch unser umfassendes Netzwerk von mehreren tausend Partnerhändlern können wir ein bestmögliches Kaufangebot für dein Auto erzielen.'
            },
            {
                title: 'Kann ich mein altes Auto für ein neues in Zahlung geben?',
                description: 'Selbstverständlich. Suche dir auf unserer Seite ganz einfach ein neues Auto online aus. Wenn wir dein neues Wunschfahrzeug zu dir nach Hause liefern, holen wir deinen Gebrauchten ab. Auto online kaufen: <a href="/auto-online-kaufen/" title="Auto Online Kaufen">https://www.pkw.de/auto-online-kaufen/</a>'
            },
            {
                title: 'Wie wird der Preis für meinen Gebrauchtwagen ermittelt?',
                description: 'Der Preis wird transparent, fair und marktaktuell durch unsere TÜV-zertifizierte Marktwertanalyse ermittelt. Dabei werden alle wertbeeinflussenden Faktoren, wie z. B. Ausstattung, Alter, Laufleistung etc., berücksichtigt. Je mehr Informationen eingegeben werden, desto besser können wir den Preis ermitteln.'
            },
            {
                title: 'Wer holt mein Auto ab?',
                description: 'Entweder verkaufst du dein Auto direkt vor Ort an einer PKW.de-Ankaufstation. Oder online – dann kümmert sich der Höchstbietende um die Abholung. Dir entstehen keine Kosten.'
            },
            {
                title: 'Muss ich mein Auto verkaufen?',
                description: 'Nein, Du entscheidest, ob du das Ankaufangebot bei einer lokalen PKW.de-Ankaufstation oder das Höchstgebot beim Onlineverkauf annimmst. Dir entsteht nur eine Bearbeitungspauschale von 149,- €, wenn du beim Onlineverkauf trotz bindendem Höchstgebot nicht verkaufen möchtest.'
            },
            {
                title: 'Werde ich von Händlern kontaktiert?',
                description: 'Nein! Beim lokalen Verkauf an eine PKW.de-Ankaufstation vereinbarst du ganz bequem online einen Termin bei einer Ankaufstation in deiner Nähe. Beim Online-Verkauf meldet sich nur der Höchstbietende bei dir, wenn du dem Verkauf zustimmst, um die Bezahlung und Abholung zu klären.'
            },
            {
                title: 'Was muss ich zum Verkauf bei einer PKW.de-Ankaufstation mitbringen?',
                description: `Damit du direkt vor Ort dein Auto verkaufen kannst, solltest du alle notwendigen Papiere mitbringen.
                    <ul class="styled-list">
                        <li>alle Fahrzeugschlüssel</li>
                        <li>Zulassungsbescheinigung Teil 1 (Fahrzeugschein)</li>
                        <li>Zulassungsbescheinigung Teil 2 (Fahrzeugbrief)</li>
                        <li>aktuellen Personalausweis oder Pass</li>
                        <li>Serviceheft (falls vorhanden)</li>
                        <li>Bescheinigung der letzten Haupt- und Abgasuntersuchung (falls vorhanden)</li>
                        <li>Werkstattrechnungen (falls vorhanden)</li>
                    </ul>
                `
            }
        ]
    }),
    methods: {
        toggle(index) {
            if(this.selectedIndex === index) {
                this.selectedIndex = null;
            } else {
                this.selectedIndex = index;
            }
        }
    },
}
</script>

<style lang="scss" scoped>
    @import "~@/assets/vars";

    .faq-section {
        position: relative;
        border-top: 3px solid #C0141B;
        padding:40px 0 20px;
        background: #f2f2f2;

        @include breakpoint(frommediumlarge) {
            padding:50px 0;
        }

        @include breakpoint(fromgiant) {
            padding:100px 0;
        }

        .question-shevrone {
            position: absolute;
            top: 0;
            left: 18px;

            @include breakpoint(fromgiant) {
                left: 10vw;
            }
            @media (min-width: 2150) {
                left: calc(50vw - (1300px / 2));
            }
        }

        h3.faq-title {
            br {
                @include breakpoint(frommediumlarge) {
                    display:none;
                }
            }
        }
    }
    .faq-container {
        padding-top:17px;

        @include breakpoint(frommediumlarge) {
            padding-top:0;
        }

        @include breakpoint(fromgiant) {
            padding-top:17px;
        }
        &.responsive {
            @media screen and (min-width:650px) {
                display: grid;
                gap: 0 18px;
                grid-template-columns: 1fr 1fr;
            }
        }
    }

    .section-title {
        margin-top: 40px;

        @include breakpoint(fromgiant) {
            margin-top: initial;
        }
    }
    .faq-card {
        margin-bottom: 25px;
        display:block;

        .question {
            display:flex;
            align-items: center;
            justify-content: flex-start;

            .prefix-icon {
                margin-right:13px;
                padding-top:4px;
                .icon {
                    font-size:32px;
                }

                &.small-icon {
                    .icon {
                        font-family: 'Glyphter', sans-serif;
                        color:rgba(#444,.5);
                        font-size:20px;
                    }
                }
            }
        }
        .faq-title {
            background-color: $white;
            border:1px solid $border-color;
            border-radius: 4px;
            cursor: pointer;
            padding: 20px;
            padding-right: 44px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color:$black-variant;
            position:relative;
            transition:300ms background-color ease-in-out, 300ms color ease-in-out, 300ms border ease-in-out;


            &:after {
                font-family: "Material Icons";
                content: "\e145";
                position:absolute;
                display:block;
                top:18px;
                right:19px;
                color:#DADADA;
                font-size:24px;
                transition:300ms color ease-in-out;
            }

            .question {
                width:calc(100% - 30px)
            }

            &:hover,
            &:focus,
            &:active,
            &.active {
                background-color: $red;
                border:1px solid $red;
                color: #fff;

                &:before {
                    color:$white;
                }
            }
        }
        .faq-content {
            display:block;
            padding: 24px 0 4px;
            padding-left:0 !important;
            padding-right: 0 !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/station-components/FAQ.vue